<div class="d-lg-none d-block page-header-div">
  <fgb-page-header [pageTitle]="'nav.worksheets'" [showBalance]="false" />
</div>

<div class="pt-lg-4">
  <fgb-worksheet-list [isWorksheetPage]="true"></fgb-worksheet-list>
</div>
